import moment from 'moment'

const toNum = (v, def = 0) => (v === '' || v == null ? def : Number(v)) || def

export const INFAKT_CUSTOMER_FIELD_MAP = {
	nazwaFirmy: 'infakt_client_company_name',
	nip: 'infakt_client_nip',
	nazwaUlicy: 'infakt_client_street',
	nrBudynku: 'infakt_client_street_number',
	nrLokalu: 'infakt_client_flat_number',
	kodPocztowy: 'infakt_client_postal_code',
	nazwaMiejscowosci: 'infakt_client_city',
	adresEmail: 'infakt_client_email',
	infaktClientId: 'infakt_client_id',
}

export const appendInfaktCustomerToPayload = (payload, customer) => {
	if (!payload || !customer) return payload
	for (const [formKey, payloadKey] of Object.entries(INFAKT_CUSTOMER_FIELD_MAP)) {
		const value = String(customer[formKey] ?? '').trim()
		if (value) payload[payloadKey] = value
	}
	return payload
}

export const buildInfaktCustomerFromInvoice = (invoice) => {
	if (!invoice) return null
	const next = {}
	let hasAny = false
	for (const [formKey, payloadKey] of Object.entries(INFAKT_CUSTOMER_FIELD_MAP)) {
		const value = String(invoice[payloadKey] ?? '').trim()
		next[formKey] = value
		if (value) hasAny = true
	}
	return hasAny ? next : null
}

const linePayload = (line) => ({
	price: toNum(line?.price),
	count: toNum(line?.count),
	taxPercent: toNum(line?.taxPercent),
	subtotal: toNum(line?.subtotal),
	taxValue: toNum(line?.taxValue),
	total: toNum(line?.total),
})

export const buildPayload = f => {
	const rows = (f.products || []).map(p => ({
		name: p.name?.trim() || '',
		sku: p.sku || '',
		article_number: p.article_number || '',
		...(p.productId ? { productId: String(p.productId) } : {}),
		...(p.productName ? { productName: p.productName } : {}),
		before: linePayload(p.before),
		after: linePayload(p.after),
		price: toNum(p.price),
		count: toNum(p.count),
		taxPercent: toNum(p.taxPercent),
		subtotal: toNum(p.subtotal),
		taxValue: toNum(p.taxValue),
		total: toNum(p.total),
	}))

	const payload = {
		customerId: f.customerId ? String(f.customerId) : undefined,
		customerName: f.customerName || '',
		invoiceDate: moment(f.invoiceDate).format('YYYY-MM-DD'),
		dueDate: f.dueDate ? moment(f.dueDate).format('YYYY-MM-DD') : null,
		invoiceNumber: f.invoiceNumber || '',
		correctedInvoiceNumber: f.correctedInvoiceNumber || '',
		sourceInvoiceId: f.sourceInvoiceId || undefined,
		correctionReason: f.correctionReason || '',
		products: rows,
		discountPercent: toNum(f.discountPercent),
		subtotal: toNum(f.subtotal),
		taxTotal: toNum(f.taxTotal),
		total: toNum(f.total),
		publicNotes: f.publicNotes || '',
		privateNotes: f.privateNotes || '',
		status: f.status || 'issued',
		paymentType: f.paymentType || 'transfer',
		companyId: f.companyId || '',
		companyName: f.companyName || '',
	}

	if (f.status === 'paid') {
		if (f.paymentType) payload.paymentType = f.paymentType
		if (f.paymentDate) payload.paidDate = moment(f.paymentDate).format('YYYY-MM-DD')
	}

	return payload
}

export const updateKorektaOnServer = (KorektyService, id, payload) => KorektyService.updateKorekta(id, payload)

export const syncProductsToCatalog = async () => ({ success: true, error: null })
